<template>
  <div style="background: #f5f5f5">
    <img src="../../static/img/TopImage.jpg" class="home-banner" />
    <div class="father_div_bg">
      <el-row :gutter="50" class="product-menu">
        <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="left">
          <div class="menu">
            <div class="biaoti">
              {{ language == "zh" ? "技术支持" : "Support" }}
            </div>
            <el-menu
              :default-active="menuPosition"
              class="el-menu-vertical-demo"
              @select="handleSelect"
            >
              <el-menu-item :index="i" v-for="(item, i) in menu" :key="i">
                <span slot="title">{{
                  language == "zh" ? item.type : item.typeEn
                }}</span>
              </el-menu-item>
            </el-menu>
          </div>
          <div class="menu callus show_pc">
            <div class="text">
              {{ language == "zh" ? "联系我们" : "Contact us" }}
            </div>
            <div class="tel">
              <img src="../../static/img/50.png" /> {{ contact.tel }}
            </div>
            <div class="email">
              <img src="../../static/img/49.png" />{{ contact.email }}
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="right">
          <div v-show="showList">
            <div class="filebox">
              <div
                v-for="(item, i) in file"
                :key="i"
                class="item"
                @click="download(item.value)"
              >
                <div class="name">
                  {{ language == "zh" ? item.key : item.keyEn }}
                </div>
                <div class="download">
                  {{ (item.length / 1024000).toFixed(2) }}MB
                  <img src="../../static/img/76.png" />
                </div>
              </div>
            </div>
            <div class="fenye" v-if="fenye">
              <el-button type="info" @click="llqb">{{
                language == "zh" ? "浏览全部" : "View all"
              }}</el-button>
              <img src="../../static/img/62.png" @click="prev" />
              <span>{{ language == "zh" ? "页面" : "Page" }}</span>
              <span>
                <el-input
                  v-model="currentPage"
                  size="mini"
                  @keyup.enter.native="getInfo1"
                >
                </el-input> </span
              >/
              <span class="pageCount">{{ pageCount }}</span>
              <img src="../../static/img/61.png" @click="next" />
            </div>
            <div class="fenye" v-else>
              <el-button type="primary" @click="llqb">{{
                language == "zh" ? "分页浏览" : "Tabbed Browsing"
              }}</el-button>
              <img src="../../static/img/62.png" />
              <span>{{ language == "zh" ? "页面" : "Page" }}</span>
              <span>
                <el-input :disabled="true" v-model="currentPage" size="mini">
                </el-input> </span
              >/
              <span class="pageCount">{{ pageCount }}</span>
              <img src="../../static/img/61.png" />
            </div>
          </div>
          <MoreView
          class="filebox"
            v-show="!showList"
            ref="MoreView"
            :language="language"
          ></MoreView>
        </el-col>
        
      </el-row>
      <div class="Mymenu callus show_phone">
          <div class="text">
            {{language=='zh'?'联系我们':'Contact us'}}
          </div>
          <div class="tel">
           <img src="../../static/img/50.png" /> {{contact.tel}}
          </div>
          <div class="email">
            <img src="../../static/img/49.png" />{{contact.email}}
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import MoreView from "./CallUs/More.vue";
export default {
  components: {
    MoreView,
  },
  name: "Product",
  props: {
    language: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "type",
      },
      defaultProps1: {
        children: "children",
        label: "typeEn",
      },
      contact: {},
      fenye: true,
      tabPosition: "left",
      menuPosition: 0,
      currentPage: 1,
      tags: [],
      icon: "el-icon-plus",
      menu: [],
      menu1: [],
      file: [],
      limit: 20,
      showList: true,
    };
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.getInfo();
      this.getInfo2();
    },
  },
  mounted() {
    this.getInfo();
    this.getInfo2();
  },
  methods: {
    download(file) {
      window.open(file, "_blank");
    },
    getInfo() {
      this.$http
        .get("/hdbs/api/activity/type/list", {
          params: {
            parentType: "技术支持",
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.menu = response.data.data.filter((x) => {
                return (
                  x.parentType == "技术支持" || x.parentType == "技术支持说明"
                );
              });
              console.log(this.menu);
              this.menu1 = response.data.data.filter((x) => {
                return x.parentType == "技术支持";
              });
              this.getData();
            }
          }.bind(this)
        );
    },
    getInfo2() {
      this.$http.get("/hdbs/api/contacts/company", {}).then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.contact = response.data.data[0];
          }
        }.bind(this)
      );
    },
    prev() {
      if (this.currentPage == 1) {
        return;
      }
      this.currentPage--;
      this.getInfo1();
    },
    next() {
      if (this.currentPage == this.pageCount) {
        return;
      }
      this.currentPage++;
      this.getInfo1();
    },
    llqb() {
      this.fenye = !this.fenye;
      if (!this.fenye) {
        this.limit = 999;
        this.currentPage = 1;
      } else {
        this.limit = 10;
      }
      thie.getInfo1();
    },
    getInfo1() {
      // if (this.GetQueryString("type")) {
      //   this.menuPosition = this.GetQueryString("type");
      //   localStorage.setItem("technical_menu_position", this.menuPosition)
      // }else{
        // this.menuPosition = localStorage.getItem("technical_menu_position") ||0
      // }
      this.$http
        .get("/hdbs/api/files/list", {
          params: {
            page: this.currentPage,
            limit: this.limit,
            type: this.menu[Number(this.menuPosition)].type,
          },
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.file = response.data.page.list;
              this.pageCount = response.data.page.totalPage;
            }
          }.bind(this)
        );
    },
    handleNodeClick(data) {
      console.log(data);
      if (data.tagable) {
        let name = data.pName + "：" + data.name;
        if (this.tags.indexOf(name) >= 0) {
          return false;
        } else {
          this.tags.push(name);
        }
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`当前页: ${val}`);
    },
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1);
    },
    rowClick(row) {
      this.$router.push("/ProductIntroduce?id=" + row.id);
    },
    handleSelect(index, indexPath) {
      console.log(index)
      // console.log(indexPath)
      this.menuPosition=index;
      localStorage.setItem("technical_menu_position", index)
      this.getData();
    },
    getData(){
      this.menuPosition = localStorage.getItem("technical_menu_position") ||0
      console.log('getData=='+this.menuPosition)
      if (!this.menu[this.menuPosition].content) {
        this.showList = true;
        // this.menuPosition = index.toString();
        this.currentPage = 1;
        this.getInfo1();
      } else {
        this.showList = false;
        this.$refs.MoreView.getHtml(this.menu[this.menuPosition].id);
      }
    }
  },
};
</script>
<style lang="stylus" scoped>
.Mymenu{
  width: 100%;
  padding: 3.5rem 2rem;
  background: #fff;
  border-radius: 6px;
  font-size: 1.7rem;
  margin-bottom: 3rem;
  box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
    .biaoti{
      color: var(--mainBlue);
      margin-bottom: 3rem;
      font-size: 2.7rem;
      margin-left: 2.5rem;
      font-family: Demibold;
    }
}
.show_pc {
  display: block;
}
.show_phone {
  display: none;
}

.el-menu {
  border-right: none;
  margin-left: 0.5rem;
}

.el-menu-item {
  margin-bottom: 1rem;
  font-size: 1.7rem;
  font-family: Regular;
  color: var(--mainGary);
  height: auto;
  line-height: normal;
}

.el-menu-item.is-active {
  color: var(--mainBlue);
  background-color: #fff;
}

.el-menu-item:hover {
  outline: 0;
  background-color: #fff;
}

.home-banner {
  margin-top: calc(-65px - 6vh);
  object-fit: cover;
  width: 100%;
}

.callus {
  padding: 10px;
  font-size: 14px;

  .text {
    color: #024580;
    margin-bottom: 10px;
    margin-left: 20px;
  }

  .tel {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    img {
      width: 17px;
      margin-right: 5px;
    }
  }

  .email {
    display: flex;
    align-items: center;

    img {
      width: 17px;
      margin-right: 5px;
    }
  }
}

.product-menu {
  margin: 0 !important;

  .left {
    padding-left: 0 !important;
    margin-top: 6vh;

    .menu {
      padding: 3.5rem 2rem;
      background: #fff;
      border-radius: 6px;
      font-size: 1.7rem;
      margin-bottom: 3rem;
      box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);

      .biaoti {
        color: var(--mainBlue);
        margin-bottom: 3rem;
        font-size: 2.7rem;
        margin-left: 2.5rem;
        font-family: Demibold;
      }

      .tree {
        border-radius: 6px;
        padding: 1vw;
        font-family: 'Regular';

        /deep/.el-tree-node__content {
          margin: 10px 0;
        }
      }
    }
  }

  .right {
    margin-top: 6vh;
    background: #fff;
    border-radius: 6px;
    box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
    margin-bottom: 6vh;

    .filebox {
      padding: 3vh 1.5vw 0 1.5vw;

      .item {
        display: flex;
        justify-content: space-between;
        font-size: 1.7rem;
        border-radius: 6px;
        align-items: center;
        background: #EFEFEF;
        border: 1px solid #EFEFEF;
        margin: 2vh 0;
        cursor: pointer;
        color: #606266;

        .name {
          margin-left: 2vw;
        }

        .download {
          img {
            width: 20px;
            margin: 10px 1vw;
          }
        }
      }

      .item:nth-child(odd) {
        background: #EAEAEA;
        border: 1px solid #EAEAEA;
      }

      .item:hover {
        background: #fff;
        box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.12);
        border: 1px solid #EAEAEA;
      }
    }
  }
}

.fenye {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 0;

  img {
    width: 6px;
    margin: 0 10px;
    cursor: pointer;
  }

  /deep/ .el-input__inner {
    width: 20px;
    padding: 0;
    text-align: center;
    margin: 0 5px;
  }

  .pageCount {
    margin: 0 5px;
  }
}

.father_div_bg {
  padding: 0 20rem;
  border-radius: 6px;
  height: 100%;
}

@media screen and (max-width: 1400px) {
  .father_div_bg {
    padding: 0 1rem;
  }
}
@media screen and (max-width: 1000px) {
  
  .show_pc {
    display: none;
  }
  .show_phone {
    display: block;
  }
  .product-menu .left{
    margin-top:0;
    padding-right: 0 !important;
  }
  .product-menu .right{
    margin-top:0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Technical.vue